import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=235af2ae&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=ts&"
export * from "./Documents.vue?vue&type=script&lang=ts&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=235af2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235af2ae",
  null
  
)

export default component.exports